var map = {
	"./InpostLogo.svg": 6164,
	"./add.svg": 6018,
	"./arrow-left.svg": 7485,
	"./arrow-right.svg": 6191,
	"./arrow_down.svg": 960,
	"./chat.svg": 3058,
	"./close_icon.svg": 5608,
	"./delete.svg": 4217,
	"./download.svg": 8728,
	"./expand_icon.svg": 7875,
	"./file.svg": 346,
	"./home.svg": 2781,
	"./info_icon.svg": 3700,
	"./logo-small.svg": 6934,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./message_icon.svg": 1697,
	"./profile.svg": 2317,
	"./progress.svg": 6432,
	"./pronunciation.svg": 7186,
	"./sample_profile_img.jpg": 2761,
	"./sample_teacher.png": 8768,
	"./sample_teacher2.png": 3097,
	"./sample_teacher3.png": 438,
	"./set_class_scene.svg": 6148,
	"./settings.svg": 4369,
	"./star-empty.svg": 2364,
	"./star-filled_icon.svg": 5122,
	"./time-clock-circle_icon.svg": 7394,
	"./togglePasswordView.svg": 208,
	"./togglePasswordViewError.svg": 3466,
	"./users.svg": 8491,
	"./wordbook.svg": 3950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3809;